import type { Editor } from "@tiptap/core"

// Macros are authored in the same message typography the composer uses, so the
// saved html goes in verbatim: any normalization would re-space the author's copy.
export function insertSnippet(editor: Editor, html: string) {
	const { from } = editor.state.selection
	const charBefore = editor.state.doc.textBetween(Math.max(0, from - 1), from)
	const chain = editor.chain()
	if (charBefore === ";") {
		chain.deleteRange({ from: from - 1, to: from })
	}
	chain.insertContent(html).focus("end", { scrollIntoView: false }).run()
}
